import { I18n } from 'react-redux-i18n';

import { UserDetailsActions, SecurityActions } from "../const/ActionsConst";
import { userLoaded, loadUser } from "./UsersTableActions";
import * as actions from "./index";

import client, { clientTransformed } from '@common/utils/rest.js'

const URL_PREFIX = 'api/userMaintenance/';

export const updateProperty = (username, property, value) => (dispatch) => {
    let userData = {
        username: username,
        property: property,
        value: value
    };
    client({
        path: `${URL_PREFIX}update`,
        method: 'POST',
        entity: userData
    }).then(
        response => {
            dispatch(userLoaded(response.entity));
        },
        error => {console.log('updateProperty: ', error);}
    )
};

export const loadProfiles = () => (dispatch) => {
    client({
        path: `${URL_PREFIX}profiles`,
        method: 'GET'
    }).then(
        response => {
            dispatch(profilesLoaded(response.entity));
        },
        error => {console.log('loadProfiles: ', error);}
    )
};

export const deleteProfiles = (profiles) => (dispatch) => {
    Promise.all(
        profiles.map((profile) => {
            return client({
                path: `${URL_PREFIX}profiles/${profile}/delete`,
                method: 'POST'
            });
        })
    ).then(
        () => {
            dispatch(loadProfiles());
        },
        error => {console.log('loadProfiles: ', error);}
    )
};

export const updateProfile = (name, data) => (dispatch) => {
    client({
        path: `${URL_PREFIX}profiles/${name}`,
        method: 'POST',
        entity: data
    }).then(
        () => {
            dispatch(loadProfiles());
        },
        error => {console.log('loadProfiles: ', error);}
    )
};

export const createProfile = (name) => (dispatch) => {
    client({
        path: `${URL_PREFIX}profiles`,
        method: 'POST',
        entity: {
            name,
            classes: [1],
            licensing: { formDesign: true, individualSS: true, pedigreeSS: true, saveSSFormats: true, saveIconFormats: true, savePedigreeProperties: true, enforceDataEntryValidations: true, fields: true, pedigrees: true, individuals: true, orders: true, invites: true, invitesAdmin: true, testResults: true } ,
            useClassBased: false,
            defaultPatientsFolderId: 0,
            defaultPatientsFolderName: null,
            defaultFormats: { idsFormat: null, pdsFormat: null, sdsFormat: null, ssFormat: null, subtextFormat: null, symbolsFormat: null, dropFieldsFormat: null }
        }
    }).then(
        ({ entity }) => {
            const { code } = entity;

            if (code > 400) {
                const errorMessage = entity.errors ? entity.errors[0] : I18n.t('An error occurred while creating the profile');

                dispatch(
                    actions.showMessageBoxBasedOnData(
                        undefined, 
                        true, 
                        I18n.t('Add Profile Cancelled'), 
                        errorMessage, 
                        undefined, 
                        I18n.t('OK')
                    )
                );

                return;
            }

            dispatch(loadProfiles());
        },
        error => {console.log('loadProfiles: ', error);}
    )
};

export const updateInput = (property, value) => ({
    type: UserDetailsActions.UPDATE_INPUT,
    property: property,
    value: value
});

export const profilesLoaded = (profiles) => ({
   type: UserDetailsActions.PROFILES_LOADED,
   profiles: profiles
});

export const changeOrgName = (username, id, value) => ({
    type: UserDetailsActions.CHANGE_AMBRY_ORG_NAME,
    username: username,
    id: id,
    value: value
});

export const changeClientID = (username, id, value) => ({
    type: UserDetailsActions.CHANGE_AMBRY_CLIENT_ID,
    username: username,
    id: id,
    value: value
});

export const updateAmbryID = (username, id)  => (dispatch, getState) => {
    var ambryIdIndex = getState().userDetails.user.ambryIDs.findIndex(ambryId => ambryId.profileId == id);
    var orgName = getState().userDetails.user.ambryIDs[ambryIdIndex].organizationName;
    var clientID = getState().userDetails.user.ambryIDs[ambryIdIndex].clientID;
    let admbryID = {
        profileId: id,
        organizationName: orgName,
        clientID: clientID
    };
    client({
        path: `${URL_PREFIX}users/${encodeURIComponent(username)}/updateAmbryPortID`,
        method: 'POST',
        entity: admbryID
    }).then(
        response => {
            dispatch(updateAmbryProfileId(response.entity.profileId, id));
        },
        error => {console.log('updateAmbryID: ', error);}
    )
};

export const updateAmbryProfileId = (newProfileId, oldProfileId) => ({
    type: UserDetailsActions.UPDATE_AMBRY_PROFILE_ID,
    newProfileId: newProfileId,
    oldProfileId: oldProfileId
});

export const addAmbryPortID = () => ({
    type: UserDetailsActions.ADD_AMBRY_PORT_ID
});

export const deleteAmbryPortID = id  => (dispatch, getState) => {
    if (id <= 0) {
        dispatch(removeAmbryPortId(id));
        dispatch(actions.showMessageBox(false))
    } else {
        var ambryIdIndex = getState().userDetails.user.ambryIDs.findIndex(ambryId => ambryId.profileId == id);
        var orgName = getState().userDetails.user.ambryIDs[ambryIdIndex].organizationName;
        var clientID = getState().userDetails.user.ambryIDs[ambryIdIndex].clientID;
        var username = getState().userDetails.user.username;
        let admbryID = {
            profileId: id,
            organizationName: orgName,
            clientID: clientID
        };
        client({
            path: `${URL_PREFIX}users/${encodeURIComponent(username)}/deleteAmbryPortID`,
            method: 'POST',
            entity: admbryID
        }).then(
            () => {
                dispatch(removeAmbryPortId(id));
                dispatch(loadUser(username));
                dispatch(actions.showMessageBox(false))
            },
            error => {console.log('deleteAmbryPortID: ', error);}
        )
    }
};

export const removeAmbryPortId = id => ({
    type: UserDetailsActions.REMOVE_AMBRY_PORT_ID,
    id: id
});

export const clearUserDetails = () => ({
    type: UserDetailsActions.CLEAR_USER_DETAILS
});

const saveLicensing = (licensing) => ({
    type: UserDetailsActions.SAVE_LICENSING,
    licensing,
});

export const updateLicensing = (username, useClassBased, licensing) => (dispatch) => {
    const data = {
        useClassBased,
        licensing,
    };

    client({
        path: `${URL_PREFIX}users/${username}/licensing`,
        method: 'POST',
        entity: data
    }).then(
        () => {
            dispatch(saveLicensing(data));
        },
        error => {console.error('updateLicensing: ', error);}
    )
};

export const saveCommonSecurity = classes => ({
    type: SecurityActions.SAVE,
    security: classes,
});

export const getCommonSecurity = () => (dispatch) => {
    client({
        path: `${URL_PREFIX}classes`,
        method: 'GET',
    }).then(
        (response) => {
            dispatch(saveCommonSecurity(response.entity));
        },
        error => {console.error('getCommonSecurity: ', error);}
    )
};

export const createSecurityClass = (entity) => {
    return clientTransformed({
        path: `${URL_PREFIX}classes`,
        method: 'POST',
        entity
    });
};

export const editSecurityClass = (entity) => {
    return clientTransformed({
        path: `${URL_PREFIX}classes`,
        method: 'POST',
        entity
    });
};

export const deleteSecurityClass = (id) => (dispatch) => {
    client({
        path: `${URL_PREFIX}classes/${id}`,
        method: 'POST',
    }).then(
        () => {
            dispatch(actions.showMessageBox(false));
            dispatch(getCommonSecurity());
        },
        error => {console.error('deleteSecurityClass: ', error);}
    )
};

export const saveUserSecurity = (classes) => ({
    type: UserDetailsActions.SAVE_SECURITY,
    userSecurity: classes,
});

export const updateUserSecurity = (username, classes) => (dispatch) => {
    client({
        path: `${URL_PREFIX}users/${username}/classes`,
        method: 'POST',
        entity: {
            classes
        }
    }).then(
        () => {
            dispatch(saveUserSecurity(classes));
        },
        error => {console.error('updateUserSecurity: ', error);}
    )
};

export const updateFormats = (username, data) => (dispatch) => {
    client({
        path: `${URL_PREFIX}users/${username}/formats`,
        method: 'POST',
        entity: data
    }).then(
        () => {
            dispatch(loadUser(username));
        },
        error => {console.error('updateFormats: ', error);}
    );
};